import classNames from 'classnames';

import styles from './TextWithIcon.module.css';

export const TextWithIcon = ({
    className,
    icon,
    text
}: {
    className?: string | null;
    icon: JSX.Element;
    text: React.ReactNode;
}) => {
    const customParentStyles = classNames(styles.TextWithIcon, className);
    const customIconStyles = classNames(styles.icon, className);

    return (
        <div data-testid="status-line-text" className={customParentStyles}>
            <span className={customIconStyles}>{icon}</span>
            <span className={styles.text}>{text}</span>
        </div>
    );
};
